"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseHTML;

var _html2nodelist = _interopRequireDefault(require("./_html2nodelist"));

var _init = _interopRequireDefault(require("./_init"));

// parses given HTML and returns mq instance
function parseHTML(html) {
  return new _init["default"]((0, _html2nodelist["default"])(html));
}
//# sourceMappingURL=parsehtml.js.map